export default function FeatureGrid() {
  const features = [
    {
      icon: 'ri-palette-line',
      title: 'Clean Aesthetic',
      description: 'Organize your product data with beautifully designed spreadsheet templates that make inventory management a visual pleasure rather than a chore.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20setup%20with%20a%20laptop%20displaying%20colorful%20organized%20spreadsheet%20data%2C%20surrounded%20by%20designer%20stationery%20and%20a%20small%20succulent%20plant%2C%20bright%20natural%20light%20from%20large%20window%2C%20clean%20aesthetic%20workspace%20photography&width=800&height=600&seq=feature-v3-clean&orientation=landscape',
    },
    {
      icon: 'ri-store-2-line',
      title: 'Category Hub',
      description: 'Access all 15 product categories from a single dashboard. Seamlessly navigate between Shoes, Apparel, Accessories, and more with one-click links to the main store.',
      image: 'https://readdy.ai/api/search-image?query=Organized%20retail%20display%20with%20neatly%20arranged%20clothing%20items%20on%20minimal%20wooden%20shelves%20by%20category%2C%20shoes%20hoodies%20and%20accessories%20in%20separate%20sections%2C%20bright%20boutique%20store%20interior%2C%20clean%20and%20inviting%20shopping%20environment&width=800&height=600&seq=feature-v3-hub&orientation=landscape',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'High Conversion',
      description: 'Data-driven layouts optimized for e-commerce success. Every spreadsheet template is crafted to help you track sales, monitor trends, and maximize your online store revenue.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20analytics%20dashboard%20on%20a%20large%20monitor%20showing%20sales%20charts%20and%20growth%20metrics%2C%20modern%20office%20setting%20with%20warm%20ambient%20lighting%2C%20business%20intelligence%20visualization%2C%20clean%20corporate%20aesthetic%20with%20plants&width=800&height=600&seq=feature-v3-conversion&orientation=landscape',
    },
  ];

  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16">
          <span className="text-xs md:text-sm font-medium text-foreground-500 tracking-wider uppercase">Why Litbuy</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mt-3 leading-tight">
            SEO-Optimized
            <br />
            E-Commerce Tools
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
                  <i className={`${feature.icon} text-lg md:text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">{feature.title}</h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}